<template>
  <div class="row">
    <!--    <SwappingSquaresSpinner v-if="loadingHandle"-->
    <!--      :animation-duration="1000"-->
    <!--      :size="90"-->
    <!--      :color="this.$store.getters.config.palette.primary"-->
    <!--      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"-->
    <!--    />-->
    <div class="flex xs12">
      <va-card :title="createTitle()">
      </va-card>
    </div>
    <div v-if="subscriptionType === 'free'" class="flex xs12">
      <FreeAppSubscription @handle-loader="handleLoader" />
    </div>
    <div v-if="subscriptionType === 'fix'" class="flex xs12">
      <FixAppSubscription @handle-loader="handleLoader" />
    </div>
    <div v-if="subscriptionType === 'charge'" class="flex xs12">
      <ChargesAppSubscription @handle-loader="handleLoader" />
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import FixAppSubscription from '../appSubscriptions/subscriptionType/FixAppSubscription'
import FreeAppSubscription from '../appSubscriptions/subscriptionType/FreeAppSubscription'
import ChargesAppSubscription from '../appSubscriptions/subscriptionType/ChargesAppSubscription'

export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { SwappingSquaresSpinner, FixAppSubscription, FreeAppSubscription, ChargesAppSubscription },
  name: 'CreateAppSubscription',
  data () {
    return {
      subscriptionType: null,
      loadingHandle: false,
    }
  },
  methods: {
    toDashboard () {
      this.$router.push({
        name: 'app-subscriptions',
      })
    },
    handleLoader (state) {
      this.loadingHandle = state
    },
    createTitle () {
      if (this.subscriptionType === 'fix') {
        return this.$t('subscriptions.createFixTitle')
      }
      if (this.subscriptionType === 'free') {
        return this.$t('subscriptions.createFreeTitle')
      }
      if (this.subscriptionType === 'charge') {
        return this.$t('subscriptions.createChargeTitle')
      }
    },
  },
  watch: {
  },
  computed: {
  },
  mounted () {
    this.subscriptionType = this.$route.params.type
    if (this.subscriptionType === null) {
      this.toDashboard()
    }
  },
}
</script>

<style scoped>

</style>
